/**
 * Special options for the receipt generated for this restaurant
 */
export class RestaurantReceiptRules {
	hideASAPFromReceipt:boolean;
	showTimeOrderWasMade:boolean;

	constructor(hideASAP:boolean, showOrderTime:boolean){
		this.hideASAPFromReceipt = hideASAP;
		this.showTimeOrderWasMade = showOrderTime;
	}

	static newFromAws(awsReceiptRules:any):RestaurantReceiptRules{
		if(awsReceiptRules!=null){
			return new RestaurantReceiptRules(
				awsReceiptRules.hideASAPFromReceipt!=null?awsReceiptRules.hideASAPFromReceipt:false,
				awsReceiptRules.showTimeOrderWasMade!=null?awsReceiptRules.showTimeOrderWasMade:false
			)
		}else{
			return RestaurantReceiptRules.generateDefaultReceiptRules();
		}
	}

	toAwsObj(){
		return {
			"hideASAPFromReceipt":this.hideASAPFromReceipt,
			"showTimeOrderWasMade":this.showTimeOrderWasMade
		}
	}

	static generateDefaultReceiptRules(){
		return new RestaurantReceiptRules(false, false)
	}
}